"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siloPosTypes = void 0;
exports.siloPosTypes = {
    SET_ERROR: 'CHOOSE POS SILO TYPES SET ERROR',
    SET_LOADING: 'CHOOSE POS SILO TYPES SET LOADING',
    RESET_SELECTED_POS: 'CHOOSE POS SILO TYPES RESET SELECTED POS',
    SET_SELECTED_CHECKPOINT: 'CHOOSE POS SILO TYPES SET SELECTED CHECKPOINT',
    GET_LANDING_PAGE_DATA_SILO: 'CHOOSE POS SILO TYPES GET LANDING PAGE DATA',
};
